
import React from 'react';
import { LoginCallback, useOktaAuth } from '@okta/okta-react';
import { Navigate } from 'react-router-dom';

const Callback = () => {
	const { authState } = useOktaAuth();
	if (authState?.isAuthenticated) {
		return <Navigate to="/v0/dashboard" replace />;
	}
	return <LoginCallback />;
};

export default Callback;
